import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "color", "semanticColor", "component", "href", "disabled", "role"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds";
import { Link } from "./Link";
/**
* **TextLink** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TextLink) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=423:1043)
*
* A text link is a text-based anchor link that users can follow to another place. It comes in standalone or inline variants.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/textlink)
*
* @example
* () => <TextLink href="#">Text link</TextLink>;
*
*/
export var TextLink = /*#__PURE__*/React.forwardRef(function TextLink(_ref, ref) {
  var children = _ref.children,
    color = _ref.color,
    semanticColor = _ref.semanticColor,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    href = _ref.href,
    disabled = _ref.disabled,
    role = _ref.role,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(Link, Object.assign({
    component: component,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    color: color,
    semanticColor: semanticColor,
    ref: ref,
    href: !disabled ? href : undefined,
    disabled: disabled,
    "aria-disabled": disabled,
    role: disabled && component !== 'button' ? 'link' : role
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.TextLink
  }), children);
});